<template>
  <div class="wrap">
    <!-- <el-select 
      class="area"
      v-model="inputValue" 
      :filterable="true" 
      :placeholder="realPlaceholder"
      :filter-method="getKeyWord"
      debounce="1000"
      @visible-change="inputVisibleChange"
    >
      <el-option
        v-for="(item, index) in options"
        :key="index"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select> -->
    <el-select
      class="area"
      v-model="inputValue"
      :multiple="false"
      filterable
      remote
      reserve-keyword
      :placeholder="realPlaceholder"
      :remote-method="getKeyWord"
      @visible-change="inputVisibleChange"
      :loading="loading">
      <el-option
        v-for="(item, index) in options"
        :key="index"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <label v-if="isLabel" class="title" :class="labelStatus">
      <span v-if="isImportant" class="important">*</span>
      <span>{{placeholder}}</span>
    </label>
  </div>
</template>

<script>
import debounce from '@/assets/js/util.js'
// 获取这个组件的输入数据，在调用的地方传入 @getdata=“xxxxx”  这个函数会返回输入域的输入，每次组件失焦的时候会自动更新
export default {
  data() {
    return {
      change: '',
      realPlaceholder: '',
      isFocus: false,
    }
  },

  props: {
    value: {},

    options: {
      type: Array,
      default: []
    },

    optionsLabel: {
      type: String,
      default: 'label'
    },

    loading: {
      type: Boolean,
      default: false
    },

    optionsValue: {
      type: String,
      default: 'value'
    },

    placeholder: {
      type: String,
      default: '请输入'
    },

    isLabel: {
      type: Boolean,
      default: true
    },

    isImportant: {
      type: Boolean,
      default: true
    },

    seletePrompt: {
      type: String,
      default: ''
    },

    min: {
      type: String,
      default: '0'
    },

    max: {
      type: String,
      default: '1000'
    }
  },

  computed: {
    inputValue: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
        
      }
    },

    labelStatus() {
      if (this.isFocus) {
        return 'focus'
      } else if (this.inputValue) {
        return 'blur'
      } else {
        return ''
      }
    }
  },

  methods: {
    inputVisibleChange(status) {
      if (status) {
        this.inputFocus()
      } else {
        this.inputBlur()
      }
    },

    getKeyWord(keyWord) {
      if(keyWord.replace(/\s+/g, '')) {
        console.log(keyWord)
        this.$emit('searchEvent', keyWord)
      }
    },

    inputFocus() {
      this.isFocus = true
      this.change = 'focus'
    },

    inputBlur() {
      this.isFocus = false
      this.change = 'blur'
    }
  },

  watch: {
    change(val) {
      if (val === 'focus') {
        if (this.isLabel ) {
          this.realPlaceholder = this.seletePrompt
        }
      } else {
        this.realPlaceholder = ''
      }

      if (val === 'blur') {
        this.realPlaceholder = ''
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  position: relative;

  .area {
    width: 100%;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: #333333;
  }

  .title {
    position: absolute;
    left: 13px;
    top: 20px;
    margin-top: -7px;
    padding: 2px 3px;
    font-size: 14px;
    transform-origin: 0 0;
    background: #fff;
    color: #c1c4cc;
    transition: all .25s;
    pointer-events: none;
  }

  .important {
    position: relative;
    top: 3px;
    margin-right: 2px;
    font-size: 16px;
    font-weight: bold;
    color: #E51C23;
  }

  .focus {
    font-size: 12px;
    color: #08A681;
    padding: 2px 3px;
    font-weight: bolder;
    letter-spacing: 0;
    line-height: 16px;
    transform: translate(-2px, -22px);
  }

  .blur {
    font-size: 12px;
    color: #666666;
    padding: 2px 3px;
    letter-spacing: 0;
    line-height: 16px;
    transform: translate(-2px, -22px);
  }

  .el-selete-border-bug {
    /deep/ .el-selete {
      border: 1px solid #DCDFE6;
    }
  }
}
</style>
